module.exports = "/images/login-panel.jpg?d1ffabae5043b953c68a83d1bda7da17";